module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Image-ac33ba3a61134692abd1ee23dd19dd4c.svg";